import * as React from 'react';
import { Switch as BaseSwitch } from '@mc/react-core';
import classNames from 'classnames';
import * as Classes from '../Classes';

type Props = Omit<
  React.ComponentProps<typeof BaseSwitch> & {},
  'large' | 'labelElement'
>;

/**
 * @deprecated nechceme používat takto, má se používat přímo z core a pro formuláře pak F.Switch, komponenta bude v budoucnu odstraněna
 */
export class Switch extends React.PureComponent<Props> {
  render() {
    const { className, ...other } = this.props;
    let cls = classNames(Classes.UI_SWITCH, className && className);

    return <BaseSwitch className={cls} {...other} />;
  }
}
